import { createVanIconComponent } from "./van"

const StopCircle = createVanIconComponent("stop-circle")
export default StopCircle
